module.exports = __webpack_public_path__ + "static/media/sidebar-ad-festive.03969519.jpg";